import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { RegistrationComponent } from '../registration/registration.component';
import { ResetPasswordComponent } from '../../modals/reset-password/reset-password.component';
import { AuthServiceService } from '../../services/auth_services/auth-service.service';
import { StorageServicesService } from '../../services/storage_services/storage-services.service';
import { Login_pObj } from '../../services/payload/login_pobj';
import { FormsModule } from '@angular/forms';
import { AlertComponent } from '../../components/alert/alert.component';
import { AlertController } from '@ionic/angular';
import { UserServiceService } from '../../services/user_service/user-service.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { UserInfo_pObj } from '../../services/payload/userInfo_pobj';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { UserInfo } from '../../services/payload/userInfo_pobj';
import { StmgService } from '../../services/state_Management/stmg.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  @Input() selectedinfoCategories: any;

  loginEmail: string;
  loginPassword: number;
  userData: any;
  userInfo: any = [];
  userInfo2: UserInfo;
  failedreason: string = "";
  is_registered: boolean;
  // @ViewChild("myInput") private emailTextBox: ElementRef;


  constructor(
    public modalController: ModalController,
    private navCtrl: NavController,
    private authService: AuthServiceService,
    private storageService: StorageServicesService,
    public alertController: AlertController,
    private userService: UserServiceService,
    private http: HttpClient,
    public formBuilder: FormBuilder,
    private stmgService: StmgService,
    public router:Router,
    public translate: TranslateService  ) {
  }

  loginForm: FormGroup;

  get errorControl() {
    return this.loginForm.controls;
  }

  ngOnInit() {
    this.loginEmail=JSON.parse(this.storageService.getLocal('email')) 
    if(JSON.parse(this.storageService.getLocal('email')) ){
      this.is_registered=true
    }else{
      this.is_registered=false
    }
    // this.emailTextBox.nativeElement.focus();
    this.loginForm = this.formBuilder.group({
      lEmail: ['', [Validators.required, Validators.pattern('[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}')]],
      lPassword: ['', [Validators.required]],
    })
  }

  login() {

    var loginParams = new Login_pObj();
    loginParams.pinNumber = this.loginPassword;
    loginParams.emailId = this.loginEmail;

    this.authService.loginService(loginParams).subscribe(data => {
      let loginData = data;
      // var loginDataSessionString = this.storageService.getLocal("account");
      // console.log("account no from local : ", loginDataSessionString);

      if (loginData.status == 'success') {
        // setTimeout(() => {
        //   console.log("object");
        //   this.stmgService.updateLoginStatus(false);
        // }, 1000*60*5);


        this.loggedData(data)
        this.storageService.localStore("accountNo", loginData.account);
        this.storageService.localStore("token", loginData.token);
        this.stmgService.updateLoginStatus(true);
        this.dismiss()
        this.successfullyLogged()

        //call getUserInfo service 
        this.getUserInfo(loginData);
      }
      else {
        this.failedreason = loginData.reason;
        this.loginError()
      }

    }, (error) => {
      //console.log(error);
      this.loginError()
    });

  }

  loggedData(d: any) {
    this.stmgService.updateLoginData(d);
  }

  getUserInfo(data: any) {
    let userInfoPayload = new UserInfo_pObj();
    userInfoPayload.account = data.account;
    userInfoPayload.token = data.token;

    if (data.account != undefined) {
      this.userService.getUserInfo(userInfoPayload).subscribe(data => {
        this.validatePayload(data);
        //console.log("data set::", data);
        this.storageService.localStore("email", data.email);
      }, (error) => {

      });
    }

  }

  validatePayload(data) {
    if (data.status !== 1 || !data.accountNumber) {
      let alert = new AlertComponent(this.alertController);
      alert.launchAlert("", "User Info", "No Infomations for this User");
    } else {
      //console.log("success")
    }
  }

  successfullyLogged() {
    let alertTitle:string;
    let alertDesc:string;
    this.translate.get('ALERTS.LOGIN_SUCC.TITLE').subscribe((res: string) => {
      alertTitle=res;
    });
    this.translate.get('ALERTS.LOGIN_SUCC.DESC').subscribe((res: string) => {
      alertDesc=res;
    });
    this.router.navigate(['/home/nextten'], { replaceUrl: true });
    let alert = new AlertComponent(this.alertController);
    alert.loginSuccessAlert("", alertTitle,alertDesc);
  }

  loginError() {
    let alertTitle:string;
    let alertDesc:string;
    this.translate.get('ALERTS.LOGIN_ERR.TITLE').subscribe((res: string) => {
      alertTitle=res;
    });
    this.translate.get('ALERTS.LOGIN_ERR.DESC').subscribe((res: string) => {
      alertDesc=res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.loginErrorAlert("", alertTitle, alertDesc+" "+ this.failedreason);
  }

  async newAccount() {
    this.dismiss();
    const modal = await this.modalController.create({
      component: RegistrationComponent,
      cssClass: 'customPopup'
    });
    return await modal.present();
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  async resetPassword() {
    await this.modalController.dismiss(); 
    
    const modal = await this.modalController.create({
      component: ResetPasswordComponent,
      cssClass: 'customPopup'
    });
    return await modal.present();
  }

}
